import { Columns3Icon, RotateCcwIcon } from "lucide-react"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

import type { WebhooksTableColumnItem } from "./table-data"
type ColumnToggleProps = {
  columns: WebhooksTableColumnItem[]
  columnVisibility: Record<string, boolean>
  toggleColumnVisibility: (key: string) => void
  resetToDefault: () => void
  isDefaultColumns: boolean
}
export const ColumnToggle = ({
  columns,
  columnVisibility,
  toggleColumnVisibility,
  resetToDefault,
  isDefaultColumns,
}: ColumnToggleProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          <Columns3Icon className="-ms-1 me-2 opacity-60" size={16} />
          Colunas
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuLabel>Alternar colunas</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {columns.map((column) => (
          <DropdownMenuCheckboxItem
            key={column.key}
            checked={columnVisibility[column.key]}
            onCheckedChange={() => toggleColumnVisibility(column.key)}
            onSelect={(e) => e.preventDefault()}
          >
            {column.header.content}
          </DropdownMenuCheckboxItem>
        ))}
        {!isDefaultColumns && (
          <>
            <DropdownMenuSeparator />
            <Button
              variant="ghost"
              size="sm"
              className="w-full justify-start"
              onClick={resetToDefault}
            >
              <RotateCcwIcon className="mr-2" size={14} />
              Restaurar padrão
            </Button>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
